import React from "react";
import { useSelector } from "react-redux";
import Footer from "../components/Footer";
import NavBar from "../components/NavBar";
import { Card, Button } from "antd";
import "./styles/notifications.css";
import PDF from "../assets/pdfs/T1 Privacy Statement.pdf";
import { useNavigate } from "react-router-dom";
import { DownloadOutlined, BackwardOutlined } from "@ant-design/icons";
const PrivacyAgreement = () => {
  const history = useNavigate();
  const namingData = useSelector((state) => state.user);
  //console.log(namingData);
  return (
    <div>
      {" "}
      <div className="main-body">
        <header>
          <NavBar data={namingData.data} />
        </header>
        <div className="main-container">
          <div className="first-pp">
            <div style={{ width: "75%", margin: "0 auto" }}>
              <Card
                // size="small"
                hoverable
                bodyStyle={{
                  padding: "2rem",
                  paddingTop: "0",
                  paddingBottom: "1rem",
                }}
                style={{
                  width: "auto",
                  paddingBottom: 10,
                  marginTop: 20,
                  borderRadius: 15,
                }}
              >
                <>
                  <div
                    className="myapps"
                    style={{
                      textAlign: "center",
                      fontSize: "1.9rem",
                      fontWeight: "600",
                    }}
                  >
                    PRIVACY STATEMENT{" "}
                  </div>
                  <div className="privacy-container-2">
                    <p>Last updated: May 1, 2023</p>
                    <br />
                    <p>
                      Training Network (dba Trainery) is committed to respecting
                      your privacy concerns and ensuring the security of the
                      information you entrust with us. The following outlines
                      the privacy practices for our entire website, our methods
                      of enforcing strict security measures for your privacy,
                      and our practices regarding this issue.
                    </p>
                    <br />
                    <h3>Personal Information</h3>
                    <p>
                      Trainery may request your name, e-mail address, other
                      unique identifiers such as an employee ID, and/or other
                      descriptive information when you register as a new user.
                      The primary purpose for collecting this information is to
                      register you in our database so you can use our SaaS
                      service. We store the information at the request of your
                      organization and use it solely for your organization's
                      business purposes. Staff at Trainery may also access this
                      information to carry out administrative tasks on behalf of
                      your organization or to troubleshoot and resolve issues
                      that may arise.
                    </p>
                    <p>
                      Except in circumstances where we believe in good faith
                      that the law requires disclosure of information, we do not
                      use your personal information for any other purposes. We
                      do not provide your information to any other parties, and
                      it is not sold or used for marketing purposes.
                      Furthermore, we do not use "tracking cookies" to report
                      your activities on this site to advertisers or any other
                      outside party.
                    </p>
                    <br />
                    <h3>Data Storage</h3>
                    <p>
                      We implement appropriate controls to ensure your personal
                      information remains secure. This includes:
                    </p>
                    <ul>
                      <li>Using data encryption at rest where appropriate</li>
                      <li>
                        Using data encryption in online data transmissions
                      </li>
                      <li>
                        Implementing data retention policies to delete or
                        anonymize legacy data
                      </li>
                      <li>
                        Utilizing third-party providers to store credit card
                        numbers
                      </li>
                      <li>
                        Minimizing information shared with third parties we
                        integrate with
                      </li>
                    </ul>
                    <br />
                    <h3>Data Retention</h3>
                    <p>
                      Our policy is to delete all client data one (1) year after
                      it was last used, unless it is needed to actively deliver
                      Services to you or for a legitimate business use,
                      including:
                    </p>
                    <ul>
                      <li>
                        A need to preserve data to ensure proper accounting
                      </li>
                      <li>
                        A need to preserve data to maintain accurate business
                        records
                      </li>
                      <li>
                        A need to preserve data to comply with contractual
                        obligations
                      </li>
                      <li>
                        A need to preserve data as part of an investigation, a
                        legal process, or enforcement of rights
                      </li>
                    </ul>
                    <br />
                    <h3>Security</h3>
                    <p>
                      Our website employs security measures to protect against
                      the loss, misuse, and alteration of the information under
                      our control. Trainery uses industry-standard efforts to
                      safeguard the confidentiality of your personally
                      identifiable information.
                    </p>
                    <p>
                      You play a significant role in the security of your
                      personal information. A breach of your privacy can occur
                      if you reveal your username and password to others. You
                      are solely responsible for maintaining the secrecy of your
                      passwords and/or any account information. Please exercise
                      caution and responsibility whenever you are online.
                    </p>
                    <p>
                      We store subscriber and personal information securely.
                      Such files are stored in secure areas not accessible to
                      the public. The website is hosted on a secure server as
                      indicated by the <strong>https://</strong> in the URL
                      location.
                    </p>
                    <br />
                    <h3>Additional Information</h3>
                    <p>
                      <strong>Minimum Age:</strong> Our services require all
                      users to be 18 or older. Our services are not intended nor
                      designed to solicit usage from individuals under the age
                      of 18.
                    </p>
                    <br />
                    <h3>Policy Updates</h3>
                    <p>
                      We reserve the right to modify this Privacy Policy at any
                      time. Changes will be posted to this web page with an
                      updated time stamp. Material changes to this policy will
                      result in notification at least thirty (30) days before
                      implementation.
                    </p>
                    <br />
                    <h3>Contact</h3>
                    <p>
                      At Trainery, we understand and respect your privacy
                      concerns. We provide the preceding information concerning
                      our privacy policy so that you may visit our website
                      without being concerned for your personal security. We
                      welcome your comments on this policy. You may contact us
                      at:
                    </p>
                    <p>
                      Trainery
                      <br />
                      6801 Pleasant Pines Dr Ste 103
                      <br />
                      Raleigh, NC 27613
                      <br />
                      800-397-5125
                      <br />
                      support@trainery.one
                    </p>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      height: "2rem",
                      paddingTop: "1rem",
                    }}
                  >
                    <Button
                      key="back"
                      style={{ marginRight: "1rem", fontSize: "1.5rem" }}
                      onClick={() => {
                        history("/home");
                      }}
                    >
                      <BackwardOutlined /> Back
                    </Button>

                    <Button
                      type="primary"
                      href={PDF}
                      style={{ fontSize: "1.5rem" }}
                      rel="noopener noreferrer"
                      download="T1 Privacy Statement"
                    >
                      <DownloadOutlined />
                      PDF
                    </Button>
                  </div>
                </>
              </Card>
            </div>
          </div>
        </div>
        <footer>
          <Footer />
        </footer>
      </div>
    </div>
  );
};

export default PrivacyAgreement;
